import {can} from '@helpers/permissions'

export default {
  methods: {
    $can (permission) {
      return can(this.$store.state.permissions, permission)
    }
  }
}
